module.exports = __webpack_public_path__ + "img/users-medical.99a00f07.svg";